import EmptyView from '../pisadropdown/emptyview';

export default class MessageBoxView extends EmptyView {

	constructor( classesList = [] ) {
		super( classesList );
		this.extendTemplate( {
			attributes: {
				class: [ "cke5-message-box", "cke5-message-box-white" ]
			}
		} );
	}

	focus() {
		//TODO add override annotation
		return void 0;
	}

}
